import { createAction } from 'redux-actions';
import { Map as ImmutableMap } from 'immutable';

import { rootUiActions, rootUiTypes } from 'companion-app-components/flux/root-ui';

export const DIALOG_TYPE = 'ADD_SCHEDULED_LIGHT_DIALOG';

export const scheduledTransactionLightEditDialog = createAction(
  rootUiActions.createDialog.toString(),
  (scheduledTransaction) => rootUiTypes.mkRootUiData({
    type: DIALOG_TYPE,
    allowNesting: true,
    props: ImmutableMap({
      scheduledTransaction,
    }),
  }),
);
